"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AvatarComponent.default;
  }
});

var _AvatarComponent = _interopRequireDefault(require("./Avatar-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }